import React, { useEffect, useState } from "react"
import { Button, Col, Divider, Form, Input, Row } from "antd"

import { FormItem } from "../custom"
import { put } from "../../utils/axios"
import { apiUrl } from "../../utils/api"
import { NotifyError, NotifySuccess } from "../../utils/notification"
import { MESSAGES } from "../../utils/constants"

const ProfileForm = ({ profile }) => {
  const [profileForm] = Form.useForm()
  const [passwordForm] = Form.useForm()

  const onSubmit = (values) => {
    put(`${apiUrl}/profile`, values).then((submitResponse) => {
      if (submitResponse.isOk) NotifySuccess(MESSAGES.SUCCESS)
      else NotifyError(submitResponse.message)
    })
  }
  const onPasswordSubmit = (values) => {
    put(`${apiUrl}/profile/password`, values).then((submitResponse) => {
      if (submitResponse.isOk) {
        NotifySuccess(MESSAGES.SUCCESS)
        passwordForm.resetFields()
        console.log(passwordForm.getFieldsValue())
      } else NotifyError(submitResponse.message)
    })
  }

  useEffect(() => {
    profileForm.setFieldsValue(profile)
  }, [profile])

  return (
    <Row>
      <Col span={24}>
        <Form form={profileForm} name="profile-form" className="profile-form" onFinish={onSubmit}>
          <FormItem name="firstname" required input={Input} placeholder="İsim" />
          <FormItem name="lastname" required input={Input} placeholder="Soyisim" />
          <FormItem name="email" required input={Input} placeholder="Eposta" />
          <Form.Item>
            <Button type="primary" htmlType="submit" className="profile-form-button">
              Profil Güncelle
            </Button>
          </Form.Item>
        </Form>
        <Divider />
        <Form form={passwordForm} name="profile-password-form" className="profile-password-form" onFinish={onPasswordSubmit}>
          <FormItem name="oldPassword" required input={Input} placeholder="Eski Şifre" type="password" />
          <FormItem name="newPassword" required input={Input} placeholder="Yeni Şifre" type="password" />
          <FormItem
            name="newPasswordRepeat"
            required
            input={Input}
            placeholder="Yeni Şifre Tekrar"
            type="password"
            rules={[
              {
                validator: async (_, newPasswordRepeat) => {
                  if (passwordForm.getFieldValue("newPassword") != newPasswordRepeat) {
                    return Promise.reject("Şifreler aynı olmalı!")
                  }
                }
              }
            ]}
          />
          <Form.Item>
            <Button type="primary" htmlType="submit" className="profile-password-form-button">
              Şifre Güncelle
            </Button>
          </Form.Item>
        </Form>
      </Col>
    </Row>
  )
}

export default ProfileForm
